import { render, staticRenderFns } from "./KgIcon.vue?vue&type=template&id=530332ec&"
import script from "./KgIcon.vue?vue&type=script&lang=js&"
export * from "./KgIcon.vue?vue&type=script&lang=js&"
import style0 from "./KgIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports